//todo suportar correctamente a coloca��o de uma m�scara provinda de outro campo (ter _mask)
var AutoNetworkOffset = function(internal, args) {
    var info,
        _ipFieldId,
        _ip,
        _mask;

    var _calculateNetwork = function(ip, mask) {
        info = {};
        // ip

        var parsedIp = getIpFromString(ip);
        if (typeof parsedIp === 'object') {
            info.ip = parsedIp;
        } else {
            return parsedIp;
        }

        //mask
        if (!mask) {
            var fromIp = ( /\/([0-9]*)/ ).exec(ip);
            if (fromIp && fromIp.length === 2) {
                mask = fromIp[1];
            }
        }

        if (!mask) {
            info.mask_bits = 0;
            info.mask = [0, 0, 0, 0];
        } else {
            var parsedMask = getIpFromString(mask);
            if (typeof parsedMask === 'object') {

                info.mask = parsedMask;
                info.mask_bits = _getBinarystringAddress(info.mask).match(/1/g).length;

            } else if (!isNaN(mask)) {
                // noinspection JSBitwiseOperatorUsage
                if (mask > 32 | mask < 0) {
                    return 'error.mask.invalid';
                }
                info.mask_bits = mask;
                info.mask = _getAddressFromBitCount(mask);
            } else {
                return 'error.mask.invalid';
            }
        }

        //amounts
        info.amount = _getAddressAmounts(info.mask_bits);

        //network, broadcast, first and last
        if (info.mask_bits === 31) {
            info.network = _network(info.ip, info.mask);
            info.first = info.network;
            info.last = _broadcast(info.ip, info.mask);
        } else if (info.mask_bits === 32) {
            info.network = _network(info.ip, info.mask);
            info.first = info.network;
            info.last = info.first;
        } else {
            info.broadcast = _broadcast(info.ip, info.mask);
            info.network = _network(info.ip, info.mask);
            info.first = info.network.slice();
            info.first[3] += 1;
            info.last = info.broadcast.slice();
            info.last[3] -= 1;
        }
    };

    var getIpFromString = function(ip) {
        if (!ip) {
            return 'error.ip.invalid'
        }

        var ipParts = ( /^([0-9]{1,3})\.([0-9]{1,3})\.([0-9]{1,3})\.([0-9]{1,3})(\/[0-9]{1,2})?$/ ).exec(ip);
        if (!ipParts || ipParts.length !== 6) {
            return 'error.octet.length';
        }

        if (isNaN(ipParts[1]) || ipParts[1] > 255 || ipParts[1] < 0) {
            return 'error.octet.0';
        }

        if (isNaN(ipParts[2]) || ipParts[2] > 255 || ipParts[2] < 0) {
            return 'error.octet.1';
        }

        if (isNaN(ipParts[3]) || ipParts[3] > 255 || ipParts[3] < 0) {
            return 'error.octet.2';
        }

        if (isNaN(ipParts[4]) || ipParts[4] > 255 || ipParts[4] < 0) {
            return 'error.octet.3';
        }

        /* eslint-disable-next-line no-implicit-coercion  */
        return [+ipParts[1], +ipParts[2], +ipParts[3], +ipParts[4]];
    };

    var _getBinarystringAddress = function(ip) {
        var binaryString = '', octect;

        for (var i = 0; i < ip.length; i++) {
            octect = ip[i].toString(2);
            while (octect.length < 8) {
                octect = '0' + octect;
            }

            binaryString += octect;
        }


        return binaryString;
    };

    var _getAddressFromBitCount = function(bits) {
        var octect = [],
            binary = '',
            i;

        for (i = 0; i < 32; i++) {
            if (i >= bits) {
                binary += '0';
            } else {
                binary += '1';
            }
        }
        for (i = 0; i < 4; i++) {
            octect[i] = parseInt(binary.substring(0, 8), 2);
            binary = binary.substring(8);
        }

        return octect;
    };

    var getAddressFromInteger = function(intAddress) {
        var octect = [],
            binary = intAddress.toString(2),
            i;

        for (i = binary.length; i < 32; i++) {
            binary = '0' + binary;
        }

        for (i = 0; i < 4; i++) {
            octect[i] = parseInt(binary.substring(0, 8), 2);
            binary = binary.substring(8);
        }

        return octect;
    };

    var _broadcast = function(octect, mask) {
        var broadcast = [];
        broadcast[0] = octect[0] | (~mask[0] & 0xff);
        broadcast[1] = octect[1] | (~mask[1] & 0xff);
        broadcast[2] = octect[2] | (~mask[2] & 0xff);
        broadcast[3] = octect[3] | (~mask[3] & 0xff);
        return broadcast;
    };

    var _network = function(octect, mask) {
        var network = [];
        network[0] = octect[0] & mask[0];
        network[1] = octect[1] & mask[1];
        network[2] = octect[2] & mask[2];
        network[3] = octect[3] & mask[3];
        return network;
    };

    var _getAddressAmounts = function(mask) {
        if (isNaN(mask) || mask < 0) {
            return undefined;
        } else {
            if (mask <= 30) {
                return {
                    addresses: Math.pow(2, 32 - mask),
                    usable: Math.pow(2, 32 - mask) - 2
                };
            }
            if (mask === 31) {
                return {
                    addresses: 2,
                    usable: 2
                }
            } else if (mask === 32) {
                return {
                    addresses: 1,
                    usable: 1
                }
            } else {
                return undefined;
            }
        }

    };

    var _getIpFromNetworkWithOffset = function(amount) {
        if (!info.ip) return 'error.network.invalid';

        var networkInt = parseInt(_getBinarystringAddress(info.ip), 2);

        return getAddressFromInteger(networkInt + amount);
    };

    var _isInNetwork = function(ip) {
        var ipInt = parseInt(_getBinarystringAddress(ip), 2);
        var firstInt = parseInt(_getBinarystringAddress(info.network), 2);
        var lastInt = parseInt(_getBinarystringAddress(info.broadcast), 2);

        return (ipInt >= firstInt && ipInt <= lastInt)
    };

    var _offset = function(amount) {
        var error;
        var result = _getIpFromNetworkWithOffset(amount);
        if (typeof result === 'string') {
            error = result;
        }
        return {
            value: (typeof result === 'object' ? result.join(".") : null),
            warning: (!_isInNetwork(result) ? "error.offset.invalid" : null),
            error: (error ? error : null)
        }
    };

    return {
        init: function(_instance, {find, read, onChange}) {
            var target = find(args.source_field);
            _ipFieldId = target.id;
            var targetValues = read(target);

            _calculateNetwork(targetValues.value, _mask);

            internal.subscribe('field-value-change-byDef-' + target.defId, onChange );
        },
        setArgs: function(field, value) {
            if (_ipFieldId === field) {
                _ip = value;
            } else {
                // ??? isto nunca pode ser
                _mask = value;
            }

            return _calculateNetwork(_ip, _mask);
        },
        apply: function() {
            if (!info.ip) return {value: ''};
            return _offset(Number(args.offset));
        }
    }
};

export { AutoNetworkOffset };
